import { useEffect, useRef, useState } from 'react';

import { useParams } from 'react-router';

import { DashboardPageHeader } from './components/DashboardPageHeader';
import styles from './Dashboard.module.scss';
import { useGetDashboard } from '@/api/REST/dashboards/useGetDashboard';
import { PageTitle } from '@/components/global/PageTitle';
import { PanelContent } from '@/components/layouts/PanelContent';
import { EmbeddableDashboard } from '@/components/ui/Embeddable';

export const Dashboard = () => {
  const { id: dashboardId } = useParams<{ id: string }>();

  const { data: dashboardData } = useGetDashboard(Number(dashboardId));

  const innerWrapperRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const el = innerWrapperRef.current;
    if (!el) return;

    const observer = new ResizeObserver(([entry]) => {
      if (entry.contentRect.height > 0) {
        setHeight(entry.contentRect.height);
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  console.debug('height', height);

  return (
    <>
      <PageTitle title={dashboardData?.name ?? ''} />

      <PanelContent className={styles.FullHeightWrapper}>
        <DashboardPageHeader dashboardId={Number(dashboardId)} />
        <div ref={innerWrapperRef} className={styles.FullHeightInnerWrapper}>
          <EmbeddableDashboard
            id={Number(dashboardId)}
            clientContext={{
              fullScreenDashboardHeight: height,
            }}
          />
        </div>
      </PanelContent>
    </>
  );
};
